<template>
  <div class="container">
    <div style="padding: 0 10px; box-sizing: border-box; margin-top: 10px">
      <div class="recommendBox">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
          "
        >
          <div class="textTitle" style="margin-top: 13px">产品推文</div>
        </div>
        <div>
          <div
            class="displayBox"
            style="border-bottom: 1px solid #ccc; height: 120px"
            v-for="(item, index) in recommendData"
            :key="index"
            @click="productTweetsBtn(item)"
          >
            <div style="width: 60%; margin-bottom: 20px">
              <div style="font-weight: bold; font-size: 16px; margin: 10px 0">{{ item.title }}</div>
            </div>
            <div style="width: 38%; padding-right: 10px">
              <img style="width: 100%; padding: 10px" :src="item.img" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 3rem"></div>
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  name: "home",
  components: {},
  data() {
    return {
      recommendData: [
        {
          title: "医保钱包是什么，怎么用？",
          img:
            "https://tech001.oss-cn-hangzhou.aliyuncs.com/%E5%8C%BB%E4%BF%9D%E9%92%B1%E5%8C%85.png",
          imageUrl:
            "https://tech001.oss-cn-hangzhou.aliyuncs.com/%E5%8C%BB%E4%BF%9D%E9%95%BF%E5%9B%BE.png"
        },
        {
          title: "九月健康月|做好“三减三健”把疾病预防“拦在前面”!",
          img:
            "https://mdcare.oss-cn-hangzhou.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250911143906_1739_50.jpg",
          imageUrl:
            "https://mdcare.oss-cn-hangzhou.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250911143907_1740_50.jpg"
        },
        {
          title: "肺结节离“癌”有多远？",
          img:
            "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E7%BC%96%E7%BB%84%2012%403x.png",
          imageUrl:
            "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E4%BA%A7%E5%93%81/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E5%86%85%E5%AE%B9/%E8%82%BA%E7%BB%93%E8%8A%82%E6%8E%A8%E6%96%87.jpg"
        },
        {
          title: "肺结节患者调整生活方式有哪些？",
          img:
            "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E4%BA%A7%E5%93%81/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E5%86%85%E5%AE%B9/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%872.png",
          imageUrl:
            "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E4%BA%A7%E5%93%81/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E5%86%85%E5%AE%B9/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E8%AF%A6%E6%83%85%E5%9B%BE2.jpg"
        },
        {
          title: "肺结节患者饮食改善",
          img:
            "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E4%BA%A7%E5%93%81/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E5%86%85%E5%AE%B9/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%873.png",
          imageUrl:
            "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E4%BA%A7%E5%93%81/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E5%86%85%E5%AE%B9/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E8%AF%A6%E6%83%85%E5%9B%BE3.jpg"
        }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == "login") {
        setTimeout(() => {
          window.location.href = window.location.href;
        }, 500);
      }
    });
  },
  methods: {
    //产品推文
    productTweetsBtn(item) {
      this.$router.push({
        name: "home/productTweets",
        query: { imageUrl: item.imageUrl }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.displayBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.container {
  width: 100%;
  height: 100vh;
}

img {
  width: 100%;
  height: auto;
  display: block;
}

.shopBox {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid #ccc;
}

.shopFirstBox {
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.shopFirstBox > view {
  width: 50px;
  margin-right: 10px;
}

.shopLastBox {
  width: 100px;
  text-align: right;
}

.van-search__content--round {
  background-color: #fff !important;
}

.tabBox {
  height: 100px;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.recommendBox {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 15px;
}

.textTitle {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
  display: block;
}
</style>